import axios from '@/libs/api.request'

// 小说列表分页查询
export const getNovelPage = (params) => {
  return axios.request({
    method: 'get',
    url: '/novel/page',
    params
  })
}

// 小说详情（含章节列表）
export const getNovelDetail = (id) => {
  return axios.request({
    method: 'get',
    url: '/novel/detail/' + id
  })
}

// 批量保存小说章节
export const saveNovelChapters = (data) => {
  return axios.request({
    method: 'post',
    url: '/novel/batch',
    data
  })
}

// 导入小说（zip）
export const importNovel = (data) => {
  return axios.request({
    method: 'post',
    url: '/novel/import',
    data
  })
}

// 导入修改小说数据（通用Excel）
export const importNovelExcel = (data) => {
  return axios.request({
    method: 'post',
    url: '/novel/excel/import',
    data
  })
}

// 导出当前页数据（通用Excel）
export const exportNovelExcel = (params) => {
  return axios.request({
    method: 'get',
    url: '/novel/export/common',
    params,
    responseType: 'blob',
    skipIntercept: true
  })
}

// 查询小说分发合作方列表
export const getPartnerList = (params) => {
  return axios.request({
    method: 'get',
    url: '/novel/distribution/partners',
    params
  })
}

// 推送小说及章节到合作方
export const pushNovelToPartner = (data) => {
  return axios.request({
    method: 'post',
    url: '/novel/distribution/push',
    data
  })
}
